import Bacon from 'baconjs';
import $ from 'jquery';
import { isValidEmail, isValidPhoneNumber, isValidZip, isValidName } from 'scripts/tools/validation';

let $registerSearchForm;
let $successText;
let $failureText;
let buttonText;
let $button;

const genericValidationRules = [
  {
    inputGroupSelector: '#ak-sp-register-firstname-group',
    inputSelector: '#ak-sp-register-firstname',
    rulePredicate: value => value && isValidName(value),
  },
  {
    inputGroupSelector: '#ak-sp-register-email-group',
    inputSelector: '#ak-sp-register-email',
    rulePredicate: value => value && isValidEmail(value),
  },
  {
    inputGroupSelector: '#ak-sp-register-address-group',
    inputSelector: '#ak-sp-register-address',
    rulePredicate: value => value,
  },
  {
    inputGroupSelector: '#ak-sp-register-familyname-group',
    inputSelector: '#ak-sp-register-familyname',
    rulePredicate: value => value && isValidName(value),
  },
  {
    inputGroupSelector: '#ak-sp-register-phone-group',
    inputSelector: '#ak-sp-register-phone',
    rulePredicate: value => value && isValidPhoneNumber(value),
  },
  {
    inputGroupSelector: '#ak-sp-register-postalcode-group',
    inputSelector: '#ak-sp-register-postalcode',
    rulePredicate: value => value && isValidZip(value),
  },
];

const setValidationState = ($element, isValid) => {
  if (isValid) {
    $element.addClass('has-success');
    $element.removeClass('has-error');
  } else {
    $element.addClass('has-error');
    $($element).removeClass('has-success');
  }
};

const validationStreamFactory = (validationRule) => {
  Bacon.fromEvent(validationRule.inputSelector, 'change')
    .map(e => validationRule.rulePredicate(e.target.value))
    .skipDuplicates()
    .onValue(result => {
      // Update validation rule with the validation result
      validationRule.isValid = result;
      // Update state in GUI
      setValidationState(validationRule.inputGroupSelector, validationRule.isValid);
    });
};

const createValidationRules = () => {
  const rules = [];
  for (const genericRule of genericValidationRules) {
    rules.push({
      inputGroupSelector: $($registerSearchForm.find(genericRule.inputGroupSelector)),
      inputSelector: $($registerSearchForm.find(genericRule.inputSelector)),
      rulePredicate: genericRule.rulePredicate,
    });
  }
  rules.map(validationStreamFactory);
  return rules;
};

const getPerson = () => {
  return {
    firstname: $registerSearchForm.find('#ak-sp-register-firstname').val(),
    email: $registerSearchForm.find('#ak-sp-register-email').val(),
    address: $registerSearchForm.find('#ak-sp-register-address').val(),
    familyname: $registerSearchForm.find('#ak-sp-register-familyname').val(),
    phone: $registerSearchForm.find('#ak-sp-register-phone').val(),
    postalcode: $registerSearchForm.find('#ak-sp-register-postalcode').val(),
  };
};

const postRegisterSearchForm = (person, propertySearch) => {
  return $.post('/api/AktivPropertySearch/RegisterSearch', {
      person,
      propertySearch,
  });
};

const changeAttibute = (item, attribute, value) => {
  const attr = item[0].attributes.getNamedItem(attribute);
  if (attr) {
    attr.value = value;
    item[0].attributes.setNamedItem(attr);
  }
};

const resetCard = () => {
  $registerSearchForm.find('form').show();

  genericValidationRules.forEach((element) => {
    $registerSearchForm.find(element.inputGroupSelector).removeClass('has-success');
    $registerSearchForm.find(element.inputSelector).val('');
  });

  $successText.hide();
  $failureText.hide();
  $button.text(buttonText);
  $button.removeAttr('disabled');

  $registerSearchForm.find('form').show();
  $registerSearchForm.addClass('js-expandable');
};

const closeCard = () => {
  const expandable = $registerSearchForm.find('.can-expand');
  const innerExpandable = $registerSearchForm.find('.list-group-item-body');
  const headerExpandable = $registerSearchForm.find('.list-group-item-heading');

  expandable.removeClass('expanded');
  innerExpandable.height(0);
  changeAttibute(headerExpandable, 'aria-expanded', false);
  changeAttibute(innerExpandable, 'aria-hidden', true);

  setTimeout(() => { resetCard(); }, 500);
};

export const init = (_$registerSearchForm, searchTerms) => {
  $registerSearchForm = _$registerSearchForm;
  const validationRules = createValidationRules($registerSearchForm);
  $button = $registerSearchForm.find('#ak-sp-register-button');
  $successText = $registerSearchForm.find('#search-registration-successful');
  $failureText = $registerSearchForm.find('#search-registration-failure');

  buttonText = $button.text();
  const buttonBusyText = $button.attr('data-busy-text');

  $registerSearchForm.on('submit', 'form', (event) => {
    event.preventDefault();
    for (const rule of validationRules) {
      rule.inputGroupSelector.find('input').change();
    }
    const isAllValid = validationRules.every(r => r.isValid);
    if (isAllValid) {
      $button.attr('disabled', 'disabled');
      $button.text(buttonBusyText);

      postRegisterSearchForm(getPerson(), searchTerms).then(() => {
        $registerSearchForm.find('form').hide();
        $successText.show();
      }, () => {
        $registerSearchForm.find('form').hide();
        $failureText.show();
      }).always(() => {
        $registerSearchForm.removeClass('js-expandable');
        setTimeout(() => { closeCard(); }, 3000);
      });
    }
  });
};
